import { ICartEntry } from '../types';

/** Calculates the total price of a cart entry including all nested children. */
export const calculateEntryTotalPrice = (entry: ICartEntry): number => {
  const entryPrice = (entry.price?.amount ?? 0) * (entry.quantity ?? 1);
  const childrenPrice = (entry.children ?? []).reduce(
    (acc, child) => acc + calculateEntryTotalPrice(child),
    0
  );
  return entryPrice + childrenPrice;
};

/** Calculates the price of a cart entry's children. */
export const calculateEntryChildrenPrice = (entry: ICartEntry): number =>
  (entry.children ?? []).reduce((acc, child) => acc + calculateEntryTotalPrice(child), 0);
